/// <amd-module name="Release/Landing/LeftPanel/ActivePipelines/ActivePipelinesActions" />
import { ReleaseDefinition, Deployment, DeploymentStatus, DeploymentOperationStatus, ReleaseEnvironment } from "Release/Client/Contracts/Release";
import { ActionsHubBase, Action } from "DistributedTask/Flux/Actions";
import { IActiveDefinitionReference } from "Release/Landing/DataProviderContracts";

export interface IInitializeDefinitionReferencesPayload {
    activeDefinitions: IActiveDefinitionReference[] | null;
    recentDefinitions: IActiveDefinitionReference[] | null;
}

export interface IDefinitionAndDeploymentPayload {
    definition: ReleaseDefinition | undefined;
    definitionReference: IActiveDefinitionReference | undefined;
    deployment: Deployment | undefined;
}

export interface IUpdateReleaseEnvironmentStatusPayload {
    definitionId: number;
    releaseId: number;
    releaseEnvironmentId: number;
    deploymentStatus: DeploymentStatus;
    operationStatus: DeploymentOperationStatus;
}

export interface IReleaseEnvironmentStartPayload {
    environment: ReleaseEnvironment;
    definitionId: number;
}

export class ActivePipelinesActions extends ActionsHubBase {
    public static getKey(): string {
        return "release-landing-active-pipelines-actions";
    }

    public initialize(): void {
        this._initializeDefs = new Action<IInitializeDefinitionReferencesPayload>();
        this._selectAdditionalPipeline = new Action<IDefinitionAndDeploymentPayload>();
        this._onPipelineFavorited = new Action<IDefinitionAndDeploymentPayload>();
        this._onRecentFavorited = new Action<number>();
        this._updateReleaseEnvironmentStatus = new Action<IUpdateReleaseEnvironmentStatusPayload>();
        this._handleDeployJobStarted = new Action<IReleaseEnvironmentStartPayload>();
    }

    public get initializeDefs(): Action<IInitializeDefinitionReferencesPayload> {
        return this._initializeDefs;
    }

    public get selectAdditionalPipeline(): Action<IDefinitionAndDeploymentPayload> {
        return this._selectAdditionalPipeline;
    }

    public get onPipelineFavorited(): Action<IDefinitionAndDeploymentPayload> {
        return this._onPipelineFavorited;
    }

    public get onRecentFavorited(): Action<number> {
        return this._onRecentFavorited;
    }

    public get updateReleaseEnvironmentStatus(): Action<IUpdateReleaseEnvironmentStatusPayload> {
        return this._updateReleaseEnvironmentStatus;
    }

    public get handleDeployJobStarted(): Action<IReleaseEnvironmentStartPayload> {
        return this._handleDeployJobStarted;
    }

    private _initializeDefs: Action<IInitializeDefinitionReferencesPayload>;
    private _selectAdditionalPipeline: Action<IDefinitionAndDeploymentPayload>;
    private _onPipelineFavorited: Action<IDefinitionAndDeploymentPayload>;
    private _onRecentFavorited: Action<number>;
    private _updateReleaseEnvironmentStatus: Action<IUpdateReleaseEnvironmentStatusPayload>;
    private _handleDeployJobStarted: Action<IReleaseEnvironmentStartPayload>;
}
